




























import { Component, Prop, Vue } from "vue-property-decorator";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    "information-card": InformationCard,
  },
})
export default class RawMessageView extends Vue {
  @Prop({ default: null })
  rawMessage!: string;

  @Prop({ default: null })
  reference!: string;

  copyRawMessageToClipboard(): void {
    var textArea = $("#rawMessageTextarea");
    textArea.removeAttr("disabled");
    textArea.select();
    try {
      var successful = document.execCommand("copy");
      textArea.select();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }

    var selection = document.getSelection();
    if (selection != null) {
      selection.removeAllRanges();
    }

    textArea.attr("disabled", "disabled");
  }

  downloadRawMessageToClipboard(): void {
    var me = this;
    var fileName = `AZNConnect-${me.reference || "rawMessage"}`;
    me.forceFileDownload(fileName, me.rawMessage);
  }

  forceFileDownload(referenceId: string, data: any) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", referenceId + ".xml");
    document.body.appendChild(link);
    link.click();
  }
}
